import Vue from 'vue'
import router from '@/router'
import store from './store'
import '@/element-ui'
import '@/assets/styles/index.scss'

import App from './App.vue'

Vue.config.productionTip = false

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

// 解决页面返回滚动条消失问题
router.afterEach((to, from, next) => {
  document.querySelector('body').setAttribute('style', 'overflow: auto !important;')
})
new Vue({
  render: (h) => h(App),
  store,
  router
}).$mount('#app')
